<template>
  <div class="step step--large step--spaced domain-name">
    <h1 class="title--1 title--unspaced">
      On y est presque, il ne reste qu’à paramétrer votre nom de domaine.
    </h1>

    <div class="domain-name__body">
      <p class="text text--instruction">
        AVEZ-VOUS UN NOM DE DOMAINE ?
      </p>

      <GroupRadio v-model="domainNameOwner">
        <GroupRadioInput
          :value="true"
          :checked="domainNameOwner === true"
          modifier="radio-input__label--text"
        >
          <span class="radio-input-text radio-input-text--small">
            Oui
          </span>
        </GroupRadioInput>
        <GroupRadioInput
          :value="false"
          :checked="domainNameOwner === false"
          modifier="radio-input__label--text"
        >
          <span class="radio-input-text radio-input-text--small">
            Non
          </span>
        </GroupRadioInput>
      </GroupRadio>
      <p class="text text--hint">
        Un nom de domaine est essentiel dans la création de votre site. Ce nom sera
        votre identité sur internet et restera unique. Il permettra à vos internautes
        d’accéder à votre site simplement. Pour créer ce nom, il vous suffit de
        choisir un nom en lien avec votre activité ainsi qu’un suffixe (.com, .fr).
        Par exemple : cabinetdupont.fr ou avocatsdupont.com.
      </p>
    </div>

    <div v-if="domainNameOwner" class="domain-name__form">
      <p class="text text--instruction">RENSEIGNEZ VOTRE NOM DE DOMAINE</p>
      <div class="form-row">
        <input
          type="url"
          class="input"
          placeholder="https://www.pearsonspecterlitt.com"
          v-model="domainName"
        />
      </div>
    </div>

    <div v-if="domainNameOwner === false" class="domain-name__form">
      <p class="text text--instruction">
        PAS DE PROBLÈME, QUEL NOM DE DOMAINE SOUHAITERIEZ-VOUS ?
      </p>
      <p class="text text--hint">
        L’achat du nom de domaine est gratuit et compris dans nos services. <br />
        Ce nom de domaine vous appartiendra, même si vous n'utilisez plus la solution
        Solency.
      </p>
      <form @submit.prevent="checkAvaibility">
        <div class="form-row">
          <p class="text text--hint domain-name__protocole">https://www.</p>
          <input
            type="text"
            class="input"
            placeholder="pearsonspecterlitt.com"
            v-model="domainName"
          />
          <button class="button button--small domain-name__checkin" type="submit">
            Vérifier
          </button>
        </div>
      </form>

      <p
        v-if="domainNameAvaibility !== null && domainNameAvaibility"
        class="check--available"
      >
        <img src="@/assets/svg/Check.svg" alt="" />
        <br />
        Ce nom de domaine est disponible
      </p>
      <p
        v-if="domainNameAvaibility !== null && !domainNameAvaibility"
        class="check--not-available"
      >
        <img src="@/assets/svg/Bad-Check.svg" alt="" />
        <br />
        Ce nom de domaine n’est pas disponible.
      </p>
    </div>
  </div>
</template>

<script>
import { api } from '@/lib/api';
import { GroupRadio, GroupRadioInput } from '@/components/common/form';
import { required } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';

export default {
  components: { GroupRadioInput, GroupRadio },

  data() {
    return {
      domainNameOwner: null,
      domainName: '',
      domainNameAvaibility: null,
    };
  },

  methods: {
    ...mapActions({
      updateDomainName: 'site/updateDomainName',
      updateExistingDomain: 'site/updateExistingDomain',
    }),
    async checkAvaibility() {
      try {
        const response = await api.get(`/domains?name=${this.domainName}`);

        this.domainNameAvaibility = false;
        if (response.status === 200) {
          this.domainNameAvaibility = response.data.available;
        }
      } catch {
        this.domainNameAvaibility = false;
      }
    },
  },

  mounted() {
    this.$v.$touch();
    this.$emit('validate', this.$v.$invalid);
  },

  watch: {
    '$v.$invalid'(invalid) {
      this.$emit('validate', invalid);
    },

    domainName(value) {
      if (!this.$v.domainName.$invalid) {
        this.updateDomainName(value);
        this.updateExistingDomain(this.domainNameOwner);
      }
    },
  },

  validations() {
    if (!this.domainNameOwner) {
      return {
        domainNameAvaibility: {
          required,
          checked: value => value === true,
        },
        domainName: {
          required,
        },
      };
    } else {
      return {
        domainName: {
          required,
        },
      };
    }
  },
};
</script>
